import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth, API } from "../App";
import { toast } from "sonner";
import Sidebar from "../components/Sidebar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../components/ui/dialog";
import { Checkbox } from "../components/ui/checkbox";
import {
  Trash2,
  Loader2,
  AlertTriangle,
  Database,
  ShieldAlert,
  Package,
  Users,
  FileText,
  MessageSquare,
  ClipboardList,
  Briefcase,
  BarChart2,
  Lock,
  ChevronDown,
  ChevronRight,
  Phone,
  RefreshCw,
  CreditCard,
  Pill,
  UserCheck,
  Bell,
  Mail,
  Settings,
  Shield,
  FileSearch,
  Calendar,
  Building,
  Clipboard,
  History,
  Star,
  Wallet,
  PenTool
} from "lucide-react";

// Nombres amigables para las colecciones
const COLLECTION_NAMES = {
  // Mensajería
  solicitudes_mensajeria: "Solicitudes de Mensajería",
  tipos_documento_mensajeria: "Tipos de Documento",
  clientes_mensajeria: "Clientes de Mensajería",
  plantillas_mensajeria: "Plantillas de Mensajería",
  mensajeria_alertas_config: "Config. Alertas Mensajería",
  mensajeria_alertas_historial: "Historial Alertas Mensajería",
  delivery_confirmations: "Confirmaciones de Entrega",
  delivery_assets: "Fotos de Entrega",
  mensajeros: "Mensajeros",
  messenger_locations: "Ubicaciones Mensajeros",
  
  // Control de Renovaciones
  renovaciones: "Renovaciones",
  renovaciones_config: "Configuración Renovaciones",
  
  // Control de Llamadas
  llamadas_control: "Control de Llamadas",
  config_llamadas: "Configuración Llamadas",
  
  // Encuestas NPS
  encuestas_campanas: "Campañas de Encuestas",
  encuestas_respuestas: "Respuestas de Encuestas",
  encuestas_destinatarios: "Destinatarios de Encuestas",
  encuestas_plantillas: "Plantillas de Encuestas",
  encuestas_portal_config: "Configuración Portal Encuestas",
  encuestas_email_template: "Plantillas Email Encuestas",
  encuestas_email_template_recordatorio: "Plantillas Recordatorio Encuestas",
  encuestas_config_recordatorios: "Config. Recordatorios Encuestas",
  encuestas_campos: "Campos de Encuestas",
  encuestas_alertas_config: "Config. Alertas Encuestas",
  encuestas_alertas_log: "Log Alertas Encuestas",
  encuestas_scheduler_logs: "Log Programador Encuestas",
  
  // Reclutamiento
  vacantes: "Vacantes",
  candidatos: "Candidatos",
  
  // Inventario Materiales
  articulos_inventario: "Artículos",
  categorias_inventario: "Categorías",
  movimientos_inventario: "Movimientos",
  inventario_alerts_config: "Config. Alertas Inventario",
  
  // Inventario Mobiliario
  activos_mobiliario: "Activos Fijos",
  categorias_mobiliario: "Categorías",
  asignaciones_mobiliario: "Asignaciones",
  bajas_mobiliario: "Bajas de Activos",
  mantenimiento_mobiliario: "Mantenimientos",
  ubicaciones_mobiliario: "Ubicaciones",
  
  // Requisiciones
  requisiciones: "Requisiciones de Materiales",
  
  // Visitantes
  visitantes: "Registros de Visitas",
  tipos_visita: "Tipos de Visita",
  visitantes_notificaciones: "Notificaciones",
  visitantes_config: "Configuración Visitantes",
  visitantes_alert_config: "Config. Alertas Visitantes",
  
  // Gestión Humana
  empleados: "Empleados",
  empleados_nomina: "Empleados Nómina",
  solicitudes_gestion_humana: "Solicitudes GH",
  vacaciones_solicitudes: "Solicitudes de Vacaciones",
  vacaciones_saldos: "Saldos de Vacaciones",
  vacaciones_ajustes: "Ajustes de Vacaciones",
  vacaciones_pendientes: "Vacaciones Pendientes",
  avances_salario: "Avances de Salario",
  prestamos_empleados: "Préstamos",
  pagos_prestamos: "Pagos de Préstamos",
  tardanzas_ausencias: "Tardanzas y Ausencias",
  tardanzas_config: "Configuración Tardanzas",
  cumpleanos_solicitudes: "Solicitudes Día Cumpleaños",
  cumpleanos_config: "Configuración Cumpleaños",
  permisos_solicitudes: "Solicitudes de Permisos",
  permisos_saldos: "Saldos de Permisos",
  permisos_ajustes: "Ajustes de Permisos",
  tipos_permiso: "Tipos de Permiso",
  parametros_gh: "Parámetros GH",
  plantillas_gh: "Plantillas GH",
  departamentos: "Departamentos",
  dias_festivos: "Días Festivos",
  
  // Nómina
  nominas: "Nóminas",
  nominas_config: "Configuración Nóminas",
  parametros_nomina: "Parámetros Nómina",
  plantillas_nomina: "Plantillas Nómina",
  bancos_nomina_config: "Config. Bancos Nómina",
  banco_txt_formatos: "Formatos TXT Banco",
  asignaciones_masivas_log: "Log Asignaciones Masivas",
  
  // Alertas Nómina
  alertas_nomina_config: "Config. Alertas Nómina",
  alertas_nomina_historial: "Historial Alertas Nómina",
  alertas_solicitudes_config: "Config. Alertas Solicitudes",
  alertas_solicitudes_historial: "Historial Alertas Solicitudes",
  
  // Tickets
  tickets: "Tickets de Soporte",
  categorias_ticket: "Categorías de Ticket",
  ticket_files: "Archivos Adjuntos",
  prioridades_ticket: "Prioridades de Ticket",
  plantillas_tickets: "Plantillas de Tickets",
  
  // WhatsApp
  whatsapp_conversations: "Conversaciones",
  whatsapp_messages: "Mensajes",
  whatsapp_config: "Configuración WhatsApp",
  whatsapp_templates: "Plantillas WhatsApp",
  whatsapp_auto_responses: "Respuestas Automáticas",
  whatsapp_chatbot_config: "Config. Chatbot",
  whatsapp_assignment_logs: "Log Asignaciones",
  
  // Reportes y Comparaciones
  reports: "Reportes Generados",
  comparisons: "Comparaciones",
  comparaciones: "Comparaciones (Legacy)",
  aprendizaje_documentos: "Aprendizaje Documentos",
  coberturas_polizas: "Coberturas de Pólizas",
  comparativos_beneficios: "Comparativos Beneficios",
  comparativos_beneficios_ai: "Comparativos IA",
  comparativos_plan_actual: "Plan Actual Comparativos",
  plantillas_beneficios: "Plantillas Beneficios",
  diccionario_sinonimos: "Diccionario Sinónimos",
  
  // Caja Chica
  gastos_caja_chica: "Gastos",
  reposiciones_caja_chica: "Reposiciones",
  categorias_caja_chica: "Categorías",
  caja_chica_config: "Configuración",
  
  // Medicamentos
  medicamentos: "Medicamentos",
  movimientos_medicamentos: "Movimientos",
  lotes_medicamentos: "Lotes de Medicamentos",
  
  // Cuentas por Pagar
  facturas_pagar: "Facturas",
  proveedores: "Proveedores",
  pagos_facturas: "Pagos Realizados",
  categorias_facturas_pagar: "Categorías Facturas",
  cuentas_pagar_alertas_config: "Config. Alertas Cuentas",
  
  // Reglas y Alertas
  reglas_alertas: "Reglas de Alertas",
  reglas_alertas_historial: "Historial Alertas",
  eventos_personalizados: "Eventos Personalizados",
  reglas_email: "Reglas de Email",
  reglas_email_historial: "Historial Reglas Email",
  
  // Configuración y Sistema
  users: "Usuarios",
  roles: "Roles",
  system_menus: "Menús del Sistema",
  system_config: "Configuración Sistema",
  app_settings: "Configuración App",
  personalization: "Personalización",
  custom_fields: "Campos Personalizados",
  campos_personalizados: "Campos Personalizados",
  campos_obligatorios: "Campos Obligatorios",
  custom_widgets: "Widgets Personalizados",
  dashboard_configs: "Config. Dashboard",
  
  // Email y Notificaciones
  email_config: "Configuración Email",
  email_templates: "Plantillas Email",
  email_logs: "Log de Emails",
  plantillas_correo: "Plantillas de Correo",
  plantillas_correo_log: "Log Plantillas Correo",
  notificaciones: "Notificaciones",
  notifications: "Notificaciones (Sistema)",
  notification_events: "Eventos de Notificación",
  push_subscriptions: "Suscripciones Push",
  push_broadcast_log: "Log Broadcast Push",
  user_notification_preferences: "Preferencias Notificaciones",
  
  // Firma Digital
  // (las firmas se guardan en users)
  
  // Auditoría
  audit_logs: "Logs de Auditoría",
  operations_audit: "Auditoría Operaciones",
  operations_audit_log: "Log Auditoría Operaciones",
  deletion_authorizations: "Autorizaciones Eliminación",
  financial_deletion_log: "Log Eliminaciones Financieras",
  financial_edit_log: "Log Ediciones Financieras",
  
  // Backups
  backups_data: "Datos de Backups",
  backups_historial: "Historial Backups",
  
  // Otros
  assets: "Assets/Archivos",
  documents: "Documentos",
  templates: "Plantillas",
  reminders: "Recordatorios",
  chats_directos: "Chats Directos",
  chat_messages: "Mensajes de Chat",
  aseguradoras: "Aseguradoras",
  planes_cobertura: "Planes de Cobertura",
  polizas_autos: "Pólizas de Autos",
  polizas_vida: "Pólizas de Vida",
  m365_tokens: "Tokens M365",
  m365_auth_states: "Estados Auth M365"
};

// Module definitions with their collections
const MODULES = [
  {
    id: "mensajeria",
    name: "Mensajería",
    icon: MessageSquare,
    color: "bg-blue-500",
    collections: ["solicitudes_mensajeria", "tipos_documento_mensajeria", "delivery_confirmations", "delivery_assets", "mensajeros", "messenger_locations", "clientes_mensajeria", "plantillas_mensajeria", "mensajeria_alertas_config", "mensajeria_alertas_historial"],
    description: "Solicitudes, confirmaciones, mensajeros y configuración de mensajería"
  },
  {
    id: "control_renovaciones",
    name: "Control de Renovaciones",
    icon: RefreshCw,
    color: "bg-emerald-500",
    collections: ["renovaciones", "renovaciones_config"],
    description: "Renovaciones de pólizas y configuración"
  },
  {
    id: "control_llamadas",
    name: "Control de Llamadas",
    icon: Phone,
    color: "bg-violet-500",
    collections: ["llamadas_control", "config_llamadas"],
    description: "Registro y control de llamadas"
  },
  {
    id: "encuestas_nps",
    name: "Encuestas NPS",
    icon: Star,
    color: "bg-yellow-500",
    collections: ["encuestas_campanas", "encuestas_respuestas", "encuestas_destinatarios", "encuestas_plantillas", "encuestas_portal_config", "encuestas_email_template", "encuestas_email_template_recordatorio", "encuestas_config_recordatorios", "encuestas_campos", "encuestas_alertas_config", "encuestas_alertas_log", "encuestas_scheduler_logs"],
    description: "Campañas, respuestas, plantillas y configuración de encuestas"
  },
  {
    id: "reclutamiento",
    name: "Reclutamiento",
    icon: UserCheck,
    color: "bg-pink-500",
    collections: ["vacantes", "candidatos"],
    description: "Vacantes y candidatos"
  },
  {
    id: "inventario_materiales",
    name: "Inventario Materiales",
    icon: Package,
    color: "bg-green-500",
    collections: ["articulos_inventario", "categorias_inventario", "movimientos_inventario", "inventario_alerts_config"],
    description: "Artículos, categorías y movimientos de inventario"
  },
  {
    id: "inventario_mobiliario",
    name: "Inventario Mobiliario",
    icon: Briefcase,
    color: "bg-purple-500",
    collections: ["activos_mobiliario", "categorias_mobiliario", "asignaciones_mobiliario", "bajas_mobiliario", "mantenimiento_mobiliario", "ubicaciones_mobiliario"],
    description: "Activos fijos, asignaciones, bajas y mantenimientos"
  },
  {
    id: "requisiciones",
    name: "Requisiciones",
    icon: ClipboardList,
    color: "bg-teal-500",
    collections: ["requisiciones"],
    description: "Requisiciones de materiales"
  },
  {
    id: "visitantes",
    name: "Control de Visitantes",
    icon: Users,
    color: "bg-orange-500",
    collections: ["visitantes", "tipos_visita", "visitantes_notificaciones", "visitantes_config", "visitantes_alert_config"],
    description: "Registros de visitas, tipos y notificaciones"
  },
  {
    id: "gestion_humana",
    name: "Gestión Humana",
    icon: Users,
    color: "bg-indigo-500",
    collections: ["empleados", "empleados_nomina", "solicitudes_gestion_humana", "vacaciones_solicitudes", "vacaciones_saldos", "vacaciones_ajustes", "vacaciones_pendientes", "avances_salario", "prestamos_empleados", "pagos_prestamos", "tardanzas_ausencias", "tardanzas_config", "cumpleanos_solicitudes", "cumpleanos_config", "permisos_solicitudes", "permisos_saldos", "permisos_ajustes", "tipos_permiso", "parametros_gh", "plantillas_gh", "departamentos", "dias_festivos"],
    description: "Empleados, vacaciones, permisos, préstamos, tardanzas y configuración"
  },
  {
    id: "nomina",
    name: "Nómina",
    icon: Wallet,
    color: "bg-lime-600",
    collections: ["nominas", "nominas_config", "parametros_nomina", "plantillas_nomina", "bancos_nomina_config", "banco_txt_formatos", "asignaciones_masivas_log"],
    description: "Nóminas, configuración y formatos de banco"
  },
  {
    id: "alertas_nomina",
    name: "Alertas de Nómina",
    icon: Bell,
    color: "bg-amber-600",
    collections: ["alertas_nomina_config", "alertas_nomina_historial", "alertas_solicitudes_config", "alertas_solicitudes_historial"],
    description: "Configuración e historial de alertas de nómina"
  },
  {
    id: "tickets",
    name: "Mesa de Ayuda",
    icon: FileText,
    color: "bg-amber-500",
    collections: ["tickets", "categorias_ticket", "ticket_files", "prioridades_ticket", "plantillas_tickets"],
    description: "Tickets de soporte, categorías y archivos"
  },
  {
    id: "whatsapp",
    name: "WhatsApp",
    icon: MessageSquare,
    color: "bg-green-600",
    collections: ["whatsapp_conversations", "whatsapp_messages", "whatsapp_config", "whatsapp_templates", "whatsapp_auto_responses", "whatsapp_chatbot_config", "whatsapp_assignment_logs"],
    description: "Conversaciones, mensajes, plantillas y configuración"
  },
  {
    id: "reportes",
    name: "Reportes y Comparaciones",
    icon: BarChart2,
    color: "bg-cyan-500",
    collections: ["reports", "comparisons", "comparaciones", "aprendizaje_documentos", "coberturas_polizas", "comparativos_beneficios", "comparativos_beneficios_ai", "comparativos_plan_actual", "plantillas_beneficios", "diccionario_sinonimos"],
    description: "Reportes, comparaciones de documentos y aprendizaje IA"
  },
  {
    id: "caja_chica",
    name: "Caja Chica",
    icon: CreditCard,
    color: "bg-yellow-600",
    collections: ["gastos_caja_chica", "reposiciones_caja_chica", "categorias_caja_chica", "caja_chica_config"],
    description: "Gastos, reposiciones y configuración"
  },
  {
    id: "medicamentos",
    name: "Control Medicamentos",
    icon: Pill,
    color: "bg-red-500",
    collections: ["medicamentos", "movimientos_medicamentos", "lotes_medicamentos"],
    description: "Medicamentos, movimientos y lotes"
  },
  {
    id: "cuentas_por_pagar",
    name: "Cuentas por Pagar",
    icon: FileText,
    color: "bg-rose-500",
    collections: ["facturas_pagar", "proveedores", "pagos_facturas", "categorias_facturas_pagar", "cuentas_pagar_alertas_config"],
    description: "Facturas, proveedores, pagos y categorías"
  },
  {
    id: "reglas_alertas",
    name: "Reglas y Alertas",
    icon: Bell,
    color: "bg-red-600",
    collections: ["reglas_alertas", "reglas_alertas_historial", "eventos_personalizados", "reglas_email", "reglas_email_historial"],
    description: "Reglas de alertas, eventos y correos automáticos"
  },
  {
    id: "email_notificaciones",
    name: "Email y Notificaciones",
    icon: Mail,
    color: "bg-blue-600",
    collections: ["email_config", "email_templates", "email_logs", "plantillas_correo", "plantillas_correo_log", "notificaciones", "notifications", "notification_events", "push_subscriptions", "push_broadcast_log", "user_notification_preferences"],
    description: "Configuración de email, plantillas y notificaciones push"
  },
  {
    id: "auditoria",
    name: "Auditoría",
    icon: Shield,
    color: "bg-slate-600",
    collections: ["audit_logs", "operations_audit", "operations_audit_log", "deletion_authorizations", "financial_deletion_log", "financial_edit_log"],
    description: "Logs de auditoría y autorizaciones de eliminación"
  },
  {
    id: "backups",
    name: "Backups",
    icon: Database,
    color: "bg-gray-600",
    collections: ["backups_data", "backups_historial"],
    description: "Datos e historial de backups"
  },
  {
    id: "configuracion_sistema",
    name: "Configuración Sistema",
    icon: Settings,
    color: "bg-gray-700",
    collections: ["system_config", "app_settings", "personalization", "custom_fields", "campos_personalizados", "campos_obligatorios", "custom_widgets", "dashboard_configs", "system_menus"],
    description: "Configuración general, campos personalizados y menús"
  },
  {
    id: "usuarios_roles",
    name: "Usuarios y Roles",
    icon: Lock,
    color: "bg-indigo-600",
    collections: ["users", "roles"],
    description: "Usuarios del sistema y roles de acceso"
  },
  {
    id: "polizas_seguros",
    name: "Pólizas y Seguros",
    icon: FileSearch,
    color: "bg-sky-600",
    collections: ["aseguradoras", "planes_cobertura", "polizas_autos", "polizas_vida"],
    description: "Aseguradoras, planes de cobertura y pólizas"
  },
  {
    id: "otros",
    name: "Otros",
    icon: Clipboard,
    color: "bg-neutral-500",
    collections: ["assets", "documents", "templates", "reminders", "chats_directos", "chat_messages", "m365_tokens", "m365_auth_states"],
    description: "Assets, documentos, plantillas y otros datos"
  }
];

export default function LimpiezaBaseDatosPage() {
  const [loading, setLoading] = useState(false);
  const [moduleStats, setModuleStats] = useState({});
  const [collectionStats, setCollectionStats] = useState({});
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [expandedModule, setExpandedModule] = useState(null);
  const [authPassword, setAuthPassword] = useState("");
  const [deleting, setDeleting] = useState(false);
  const { getAuthHeaders } = useAuth();

  const fetchModuleStats = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/admin/database/stats`, getAuthHeaders());
      setModuleStats(res.data.modules || {});
      setCollectionStats(res.data.collections || {});
    } catch (err) {
      console.error("Error fetching stats:", err);
      setModuleStats({});
      setCollectionStats({});
    } finally {
      setLoading(false);
    }
  }, [getAuthHeaders]);

  useEffect(() => {
    fetchModuleStats();
  }, [fetchModuleStats]);

  const toggleModuleExpand = (moduleId) => {
    if (expandedModule === moduleId) {
      setExpandedModule(null);
      setSelectedCollections([]);
    } else {
      setExpandedModule(moduleId);
      setSelectedCollections([]);
    }
  };

  const toggleCollection = (collection) => {
    setSelectedCollections(prev => 
      prev.includes(collection)
        ? prev.filter(c => c !== collection)
        : [...prev, collection]
    );
  };

  const selectAllCollections = (module) => {
    if (selectedCollections.length === module.collections.length) {
      setSelectedCollections([]);
    } else {
      setSelectedCollections([...module.collections]);
    }
  };

  const openConfirmDialog = (module) => {
    if (selectedCollections.length === 0) {
      toast.error("Seleccione al menos una colección para limpiar");
      return;
    }
    setSelectedModule(module);
    setAuthPassword("");
    setShowConfirmDialog(true);
  };

  const executeCleanup = async () => {
    if (!selectedModule || !authPassword || selectedCollections.length === 0) {
      toast.error("Seleccione colecciones e ingrese su contraseña");
      return;
    }

    setDeleting(true);
    try {
      await axios.post(
        `${API}/admin/database/cleanup`,
        {
          module_id: selectedModule.id,
          collections: selectedCollections,
          password: authPassword
        },
        getAuthHeaders()
      );
      
      const collectionNames = selectedCollections.map(c => COLLECTION_NAMES[c] || c).join(", ");
      toast.success(`Limpieza completada: ${collectionNames}`);
      setShowConfirmDialog(false);
      setSelectedModule(null);
      setSelectedCollections([]);
      setExpandedModule(null);
      fetchModuleStats();
    } catch (err) {
      const errorMsg = err.response?.data?.detail || "Error al limpiar las colecciones";
      toast.error(errorMsg);
    } finally {
      setDeleting(false);
    }
  };

  const getModuleCount = (moduleId) => {
    return moduleStats[moduleId]?.total || 0;
  };

  const getCollectionCount = (collection) => {
    return collectionStats[collection] || 0;
  };

  const getSelectedCount = () => {
    return selectedCollections.reduce((sum, col) => sum + getCollectionCount(col), 0);
  };

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-slate-900">
      <Sidebar />
      
      <main className="flex-1 ml-0 md:ml-64 p-4 md:p-8 pt-14 md:pt-8 overflow-x-hidden" data-testid="limpieza-bd-page">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center">
            <Database className="w-7 h-7 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white font-['Manrope']">
              Limpieza de Base de Datos
            </h1>
            <p className="text-slate-500 dark:text-slate-400 mt-1">
              Seleccione específicamente qué datos desea eliminar de cada módulo
            </p>
          </div>
        </div>

        {/* Warning Banner */}
        <Card className="border-red-200 bg-red-50 dark:bg-red-900/20 dark:border-red-800 mb-6">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-6 h-6 text-red-600 mt-0.5" />
              <div>
                <h3 className="font-semibold text-red-800 dark:text-red-300">
                  ¡Advertencia! Acción Irreversible
                </h3>
                <p className="text-sm text-red-600 dark:text-red-400 mt-1">
                  Al limpiar datos se eliminarán de forma permanente. Esta acción no se puede deshacer. 
                  Asegúrese de tener respaldos antes de proceder.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Modules List */}
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-slate-400" />
          </div>
        ) : (
          <div className="space-y-3">
            {MODULES.map((module) => {
              const Icon = module.icon;
              const count = getModuleCount(module.id);
              const isExpanded = expandedModule === module.id;
              
              return (
                <Card 
                  key={module.id}
                  className={`border-slate-200 dark:border-slate-700 dark:bg-slate-800 transition-all ${
                    isExpanded ? 'ring-2 ring-blue-500 shadow-lg' : 'hover:shadow-md'
                  }`}
                >
                  <CardHeader className="pb-2">
                    <div 
                      className="flex items-center justify-between cursor-pointer"
                      onClick={() => toggleModuleExpand(module.id)}
                    >
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 rounded-lg ${module.color} flex items-center justify-center`}>
                          <Icon className="w-5 h-5 text-white" />
                        </div>
                        <div>
                          <CardTitle className="text-base font-semibold text-slate-900 dark:text-white flex items-center gap-2">
                            {module.name}
                            <Badge variant="outline" className="text-xs font-normal">
                              {count} registros
                            </Badge>
                          </CardTitle>
                          <p className="text-sm text-slate-500 dark:text-slate-400">
                            {module.description}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        {isExpanded ? (
                          <ChevronDown className="w-5 h-5 text-slate-400" />
                        ) : (
                          <ChevronRight className="w-5 h-5 text-slate-400" />
                        )}
                      </div>
                    </div>
                  </CardHeader>
                  
                  {/* Expanded Content - Collection Selection */}
                  {isExpanded && (
                    <CardContent className="pt-2 border-t border-slate-100 dark:border-slate-700">
                      <div className="space-y-4">
                        {/* Select All */}
                        <div className="flex items-center justify-between pb-2 border-b border-slate-100 dark:border-slate-700">
                          <div className="flex items-center gap-2">
                            <Checkbox
                              id={`select-all-${module.id}`}
                              checked={selectedCollections.length === module.collections.length}
                              onCheckedChange={() => selectAllCollections(module)}
                            />
                            <Label 
                              htmlFor={`select-all-${module.id}`}
                              className="text-sm font-medium cursor-pointer"
                            >
                              Seleccionar todo
                            </Label>
                          </div>
                          {selectedCollections.length > 0 && (
                            <Badge className="bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300">
                              {getSelectedCount()} registros seleccionados
                            </Badge>
                          )}
                        </div>
                        
                        {/* Collections List */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          {module.collections.map((collection) => {
                            const colCount = getCollectionCount(collection);
                            const isSelected = selectedCollections.includes(collection);
                            
                            return (
                              <div 
                                key={collection}
                                className={`flex items-center justify-between p-3 rounded-lg border transition-all ${
                                  isSelected 
                                    ? 'border-red-300 bg-red-50 dark:bg-red-900/20 dark:border-red-700' 
                                    : 'border-slate-200 dark:border-slate-600 hover:border-slate-300'
                                }`}
                              >
                                <div className="flex items-center gap-3">
                                  <Checkbox
                                    id={`col-${collection}`}
                                    checked={isSelected}
                                    onCheckedChange={() => toggleCollection(collection)}
                                    disabled={colCount === 0}
                                  />
                                  <Label 
                                    htmlFor={`col-${collection}`}
                                    className={`text-sm cursor-pointer ${colCount === 0 ? 'text-slate-400' : ''}`}
                                  >
                                    {COLLECTION_NAMES[collection] || collection}
                                  </Label>
                                </div>
                                <Badge 
                                  variant="outline" 
                                  className={`text-xs ${
                                    colCount === 0 
                                      ? 'text-slate-400' 
                                      : isSelected 
                                        ? 'border-red-300 text-red-600' 
                                        : ''
                                  }`}
                                >
                                  {colCount}
                                </Badge>
                              </div>
                            );
                          })}
                        </div>
                        
                        {/* Action Buttons */}
                        <div className="flex justify-end gap-2 pt-3 border-t border-slate-100 dark:border-slate-700">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => {
                              setExpandedModule(null);
                              setSelectedCollections([]);
                            }}
                          >
                            Cancelar
                          </Button>
                          <Button
                            variant="destructive"
                            size="sm"
                            onClick={() => openConfirmDialog(module)}
                            disabled={selectedCollections.length === 0}
                            data-testid={`cleanup-${module.id}`}
                          >
                            <Trash2 className="w-4 h-4 mr-2" />
                            Limpiar Seleccionados ({getSelectedCount()})
                          </Button>
                        </div>
                      </div>
                    </CardContent>
                  )}
                </Card>
              );
            })}
          </div>
        )}

        {/* Confirmation Dialog */}
        <Dialog open={showConfirmDialog} onOpenChange={setShowConfirmDialog}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 text-red-600">
                <ShieldAlert className="w-5 h-5" />
                Confirmar Limpieza
              </DialogTitle>
              <DialogDescription>
                Está a punto de eliminar datos del módulo <strong>"{selectedModule?.name}"</strong>.
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4 py-4">
              <div className="p-4 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
                <div className="flex items-start gap-3">
                  <AlertTriangle className="w-5 h-5 text-red-600 mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-red-800 dark:text-red-300">
                      Esta acción es IRREVERSIBLE
                    </p>
                    <p className="text-xs text-red-600 dark:text-red-400 mt-1">
                      Se eliminarán <strong>{getSelectedCount()} registros</strong> de:
                    </p>
                    <ul className="text-xs text-red-600 dark:text-red-400 mt-2 space-y-1">
                      {selectedCollections.map(col => (
                        <li key={col} className="flex items-center justify-between">
                          <span>• {COLLECTION_NAMES[col] || col}</span>
                          <Badge variant="outline" className="text-xs border-red-300">
                            {getCollectionCount(col)}
                          </Badge>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="auth-password">Ingrese su contraseña para confirmar</Label>
                <Input
                  id="auth-password"
                  type="password"
                  value={authPassword}
                  onChange={(e) => setAuthPassword(e.target.value)}
                  placeholder="••••••••"
                  onKeyDown={(e) => e.key === "Enter" && executeCleanup()}
                  data-testid="cleanup-password-input"
                />
              </div>
            </div>

            <DialogFooter className="gap-2">
              <Button 
                variant="outline" 
                onClick={() => setShowConfirmDialog(false)}
                disabled={deleting}
              >
                Cancelar
              </Button>
              <Button 
                variant="destructive"
                onClick={executeCleanup}
                disabled={deleting || !authPassword}
                data-testid="confirm-cleanup-btn"
              >
                {deleting ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Eliminando...
                  </>
                ) : (
                  <>
                    <Lock className="w-4 h-4 mr-2" />
                    Confirmar Eliminación
                  </>
                )}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </main>
    </div>
  );
}
